export default __webpack_public_path__ + "static/media/s_presso_brochure.5f4ac8e7.pdf";